/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Sheet_Percent_LoadInputs */

const en_us2_exercise_sheet_percent_load = /** @type {(inputs: Exercise_Sheet_Percent_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weight`)
};

const pt_br2_exercise_sheet_percent_load = /** @type {(inputs: Exercise_Sheet_Percent_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

const es_419_exercise_sheet_percent_load = /** @type {(inputs: Exercise_Sheet_Percent_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

const pt_pt2_exercise_sheet_percent_load = /** @type {(inputs: Exercise_Sheet_Percent_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carga`)
};

const fr_fr2_exercise_sheet_percent_load = /** @type {(inputs: Exercise_Sheet_Percent_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charge`)
};

const de_de2_exercise_sheet_percent_load = /** @type {(inputs: Exercise_Sheet_Percent_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewicht`)
};

const it_it2_exercise_sheet_percent_load = /** @type {(inputs: Exercise_Sheet_Percent_LoadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peso`)
};

/**
* | output |
* | --- |
* | "Weight" |
*
* @param {Exercise_Sheet_Percent_LoadInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_sheet_percent_load = /** @type {((inputs?: Exercise_Sheet_Percent_LoadInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Sheet_Percent_LoadInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_sheet_percent_load(inputs)
	if (locale === "es-419") return es_419_exercise_sheet_percent_load(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_sheet_percent_load(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_sheet_percent_load(inputs)
	if (locale === "de-DE") return de_de2_exercise_sheet_percent_load(inputs)
	if (locale === "it-IT") return it_it2_exercise_sheet_percent_load(inputs)
	return en_us2_exercise_sheet_percent_load(inputs)
});
export { exercise_sheet_percent_load as "exercise-sheet.percent_load" }